import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  RichTextField,
  BooleanField,
  SelectField,
  ArrayField,
  Datagrid,
  DateField,
} from "react-admin";
import { Typography } from "@mui/material";

import { dateOptions, languageChoices, ordersStatusChoices } from "../../../../utils/options";
import { richTextLabel } from "customStyles/ra-custom-styles";

const ShowPublicProcurementActOrders = () => {
  return (
    <Show title="Детайли за поръчка">
      <SimpleShowLayout>
        <TextField
          label="Предмет на поръчката"
          source="title"
        />
        <DateField
          label="Дата на публикуване"
          source="started_on"
          locales={"bg"}
          options={dateOptions}
        />
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <TextField
          label="АОП"
          source="agency_public_order"
        />

        <SelectField
          label="Статус"
          source="status"
          choices={ordersStatusChoices}
        />

        <TextField
          label="Възлагане чрез"
          source="procedure_name"
        />
        <TextField
          label="Отговорник"
          source="accountable_person"
        />
        <BooleanField
          label="Скрита"
          source="is_hidden"
        />

        <RichTextField
          label="Описание на поръчката"
          source="message"
          sx={richTextLabel}
        />
        <Typography>Качени файлове</Typography>
        <ArrayField
          label=""
          source="order_files"
        >
          {" "}
          <Datagrid
            bulkActionButtons={false}
            empty={<Typography sx={{ marginBottom: "40px", fontSize: ".8rem" }}>Няма зададени</Typography>}
          >
            <TextField
              label="Име на файл"
              source="name"
            />
            <TextField
              label="Линк"
              source="url"
            />
            <TextField
              label="Линк"
              source="aop_link"
            />
            <TextField
              label="Име на линка"
              source="aop_name_link"
            />
            <DateField
              label="Дата"
              source="publish_date"
              locales={"bg"}
              options={dateOptions}
            />
          </Datagrid>
        </ArrayField>
        <Typography>Съобщения</Typography>
        <ArrayField
          label=""
          source="order_messages"
        >
          {" "}
          <Datagrid
            bulkActionButtons={false}
            empty={<Typography sx={{ marginBottom: "40px", fontSize: ".8rem" }}>Няма зададени</Typography>}
          >
            <TextField
              label="Текст"
              source="message_title"
              sortable={false}
            />

            <DateField
              label="Дата"
              source="message_date"
              locales={"bg"}
              options={dateOptions}
              sortable={false}
            />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </Show>
  );
};
export default ShowPublicProcurementActOrders;
